export default __webpack_public_path__ + "static/media/desktop_logo.86aa2175.svg";